import api from '@api'; // Instead of ../../../utils/api
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../../context/AuthContext';
import './LeagueAuth.css';
import IndividualLeaguePlayersAuth from "./LeagueAuthComponents/LeaguePlayersAuth/LeaguePlayersAuth.jsx";
import TeamLeagueTeamsAuth from "./LeagueAuthComponents/LeagueTeamsAuth/LeagueTeamsAuth.jsx";
import GameInLeagueAuth from './LeagueAuthComponents/LeagueGamesAuth/LeagueGamesAuth';
import Breadcrumbs from '../../../../../components/Breadcrumbs';


function LeagueAuth() {

  const { isAuthenticated, user } = useAuth(); // ✅ Add auth state
  const [league, setLeague] = useState(null);
  const [teams, setTeams] = useState([]);
  const [teamGameCounts, setTeamGameCounts] = useState({});
  const [allPlayers, setAllPlayers] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [seasonId, setSeasonId] = useState(null);
  const { id: leagueId } = useParams();
  const [message, setMessage] = useState('')
  const FAB_ORG_ID = 1;
  const showTeamHideControls =
    Number(user?.organization_id) === FAB_ORG_ID;
  const leagueType = league?.league_type;
  const isTeamLeague = leagueType === "team";
  const isIndividualLeague = leagueType === "individual";
  const isDoublesPairLeague = leagueType === "doubles_pair";
  const [activeLeagueTab, setActiveLeagueTab] = useState("teams");

  useEffect(() => {
    const fetchSeasonIdFromSeasonLeagues = async () => {
      if (!leagueId) return;
      try {
        const res = await api.get(`/api/seasonsleagues`, {
          withCredentials: true
        });
        const entry = res.data.seasonsLeagues.find(
          (item) => item.league.id === Number(leagueId) && item.season
        );
        if (entry) {
          setSeasonId(entry.season.id);
          setLeague(entry.league)
        }
      } catch (err) {
        console.error("Error fetching seasonsLeagues:", err);
      }
    };
    fetchSeasonIdFromSeasonLeagues();
  }, [leagueId]);

  useEffect(() => {
    const fetchTeamGameCounts = async () => {
      if (!seasonId || !leagueId) return;
      try {
        const res = await api.get(
          `/api/seasonsv2/${seasonId}/leagues/${leagueId}/games`,
          { withCredentials: true }
        );
        const games = res.data.games || [];
        const counts = {};
        games.forEach((game) => {
          const homeId =
            game.home_team_id ||
            game.team1_id ||
            game.homeTeam?.id ||
            game.homeTeam?.seasons_leagues_teams_id ||
            game.home_team?.id ||
            game.home_team?.seasons_leagues_teams_id;
          const awayId =
            game.away_team_id ||
            game.team2_id ||
            game.awayTeam?.id ||
            game.awayTeam?.seasons_leagues_teams_id ||
            game.away_team?.id ||
            game.away_team?.seasons_leagues_teams_id;
          if (homeId) counts[Number(homeId)] = (counts[Number(homeId)] || 0) + 1;
          if (awayId) counts[Number(awayId)] = (counts[Number(awayId)] || 0) + 1;
        });
        setTeamGameCounts(counts);
      } catch (err) {
        console.error("Error fetching team game counts:", err);
      }
    };
    fetchTeamGameCounts();
  }, [seasonId, leagueId]);

  useEffect(() => {
    const fetchAllPlayers = async () => {
      try {
        const res = await api.get("/api/playersv2", {
          withCredentials: true,
        });
        setAllPlayers(res.data.players || []);
      } catch (err) {
        console.error("Error fetching all players:", err);
      }
    };
    if (isAuthenticated && isIndividualLeague) {
      fetchAllPlayers();
    }
  }, [isAuthenticated, isIndividualLeague]);



  return (
    <div className="league_auth">
      <Breadcrumbs />

      {message && <p className="leagueAuth-message">{message}</p>}

      {(isTeamLeague || isIndividualLeague || isDoublesPairLeague) && (
        <div className="leagueAuth-tabs">
          {!isDoublesPairLeague && (
            <button
              type="button"
              className={
                activeLeagueTab === "teams"
                  ? "leagueAuth-tab-btn leagueAuth-tab-active"
                  : "leagueAuth-tab-btn"
              }
              onClick={() => setActiveLeagueTab("teams")}
            >
              {isTeamLeague ? "Teams" : "Players"}
            </button>
          )}

          <button
            type="button"
            className={
              activeLeagueTab === "games"
                ? "leagueAuth-tab-btn leagueAuth-tab-active"
                : "leagueAuth-tab-btn"
            }
            onClick={() => setActiveLeagueTab("games")}
          >
            Games
          </button>
        </div>
      )}

      <div className="leagueAuth-section-stack">
        {activeLeagueTab === "teams" && isTeamLeague && (
          <TeamLeagueTeamsAuth
            seasonId={seasonId}
            leagueId={leagueId}
            teams={teams}
            setTeams={setTeams}
            teamGameCounts={teamGameCounts}
            showTeamHideControls={showTeamHideControls}
            allPlayers={allPlayers}
            setAllPlayers={setAllPlayers}
            setPreviewImage={setPreviewImage}
            setMessage={setMessage}
          />
        )}

        {activeLeagueTab === "teams" && isIndividualLeague && (
          <IndividualLeaguePlayersAuth
            seasonId={seasonId}
            leagueId={leagueId}
            allPlayers={allPlayers}
            previewImage={previewImage}
            setPreviewImage={setPreviewImage}
            setMessage={setMessage}
          />
        )}

        {activeLeagueTab === "games" &&
          (isTeamLeague || isIndividualLeague || isDoublesPairLeague) && (
            <GameInLeagueAuth
              leagueId={leagueId}
              seasonId={seasonId}
              leagueType={leagueType}
              teams={teams}
            />
          )}
      </div>
    </div>
  );
}

export default LeagueAuth;

